import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LogisticsEntryPage from "./pages/LogisticsEntryPage";
import LogisticsAdminPage from "./pages/LogisticsAdminPage";
import LoginPage from "./pages/LoginPage";
import Swal from "sweetalert2";
import MastersPage from './pages/MastersPage';
import './App.css';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const token = localStorage.getItem("access_token");
  const userData = localStorage.getItem("user");

  if (!token || !userData) {
    return <Navigate to="/login" replace />;
  }

  let user = null;

  try {
    user = JSON.parse(userData);
  } catch (error) {
    localStorage.removeItem("access_token");
    localStorage.removeItem("user");
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(user.user_type)) {
    Swal.fire({
  icon: "warning",
  title: "Access Restricted",
  text: "You do not have permission to access this page.",
  confirmButtonText: "Go Back",
  customClass: {
    popup: "custom-swal-popup",
    title: "custom-swal-title",
    htmlContainer: "custom-swal-text",
    confirmButton: "custom-swal-confirm",
    icon: "custom-swal-icon",
  },
  buttonsStyling: false,
});

    if (user.user_type === "ADMIN") {
      return <Navigate to="/admin" replace />;
    }

    if (user.user_type === "LOGISTICS") {
      return <Navigate to="/" replace />;
    }

    return <Navigate to="/login" replace />;
  }

  return children;
};

function App() {
  return (
    <Router>
  <Routes>
    <Route path="/login" element={<LoginPage />} />

    <Route
      path="/"
      element={
        <ProtectedRoute allowedRoles={["LOGISTICS"]}>
          <LogisticsEntryPage />
        </ProtectedRoute>
      }
    />

    <Route
      path="/admin"
      element={
        <ProtectedRoute allowedRoles={["ADMIN"]}>
          <LogisticsAdminPage />
        </ProtectedRoute>
      }
    />

    <Route
      path="/masters"
      element={
        <ProtectedRoute allowedRoles={["ADMIN"]}>
          <MastersPage />
        </ProtectedRoute>
      }
    />
  </Routes>
</Router>
  );
}

export default App;